import { Bell } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconBell12Line = createIcon(Bell, 12, "Line");
export const IconBell16Line = createIcon(Bell, 16, "Line");
export const IconBell20Line = createIcon(Bell, 20, "Line");
export const IconBell24Line = createIcon(Bell, 24, "Line");
export const IconBell32Line = createIcon(Bell, 32, "Line");
export const IconBell48Line = createIcon(Bell, 48, "Line");
export const IconBell64Line = createIcon(Bell, 64, "Line");
